




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';

const BillingForm = () => {
  const [billingData, setBillingData] = useState({
    patientId: "",
    medicineList: [{ medicineId: "", quantity: "" }],
    consultationFee: "",
    roomCharge: "",
    discount: "",
    paidAmount: "",
  });

  const [patients, setPatients] = useState([]);
  const [medicines, setMedicines] = useState([]);
const [billingList, setBillingList] = useState([]);


useEffect(() => {
  const fetchBillingData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get("http://3.110.167.23:8080/api/v1/billing", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setBillingList(response.data);
    } catch (error) {
      console.error("Error fetching billing data:", error);
      alert("Failed to fetch billing data.");
    }
  };

  fetchBillingData();
}, []);



  // Fetch patients on component mount
  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${API_PATH}/patients`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setPatients(response.data);
      } catch (error) {
        console.error('Error fetching patients:', error);
        alert('Failed to fetch patients. Please login again.');
      }
    };

    fetchPatients();
  }, []);

  // Fetch medicines on component mount
  useEffect(() => {
    const fetchMedicines = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${API_PATH}/medicines`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setMedicines(response.data);
      } catch (error) {
        console.error('Error fetching medicines:', error);
        alert('Failed to fetch medicines.');
      }
    };

    fetchMedicines();
  }, []);







  const handleMedicineChange = (index, field, value) => {
    const updatedList = [...billingData.medicineList];
    updatedList[index][field] = value;
    setBillingData({ ...billingData, medicineList: updatedList });
  };

  const addMedicine = () => {
    setBillingData({
      ...billingData,
      medicineList: [...billingData.medicineList, { medicineId: "", quantity: "" }],
    });
  };

  const removeMedicine = (index) => {
    const updatedList = billingData.medicineList.filter((_, i) => i !== index);
    setBillingData({ ...billingData, medicineList: updatedList });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");
    const payload = {
      ...billingData,
      patientId: parseInt(billingData.patientId),
      medicineList: billingData.medicineList.map(med => ({
        medicineId: parseInt(med.medicineId),
        quantity: parseInt(med.quantity)
      })),
      consultationFee: parseInt(billingData.consultationFee) || 0,
      roomCharge: parseInt(billingData.roomCharge) || 0,
      discount: parseInt(billingData.discount) || 0,
      paidAmount: parseInt(billingData.paidAmount) || 0,
    };
    try {
      const response = await axios.post(
        `${API_PATH}/billing`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      console.log('Billing submitted successfully:', response.data);
      alert('Billing submitted successfully!');
      // Reset form
      setBillingData({
        patientId: "",
        medicineList: [{ medicineId: "", quantity: "" }],
        consultationFee: "",
        roomCharge: "",
        discount: "",
        paidAmount: "",
      });
    } catch (error) {
      if (error.response && error.response.status === 403) {
        alert('Forbidden: You do not have permission. Please login again.');
      } else {
        console.error('Error submitting billing data:', error);
        alert('Failed to submit billing data.');
      }
    }
  };

  return (
    <div className="container my-5 w-100 mw-100" >
      <div className="container my-5 w-100 mw-100">
        <div className="card-header text-white" style={{background:"rgb(33, 118, 111)"}}>
          <h4 className="mb-0">Billing Form</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>

            {/* Patient Dropdown */}
            <div className="mb-3">
              <label className="form-label fw-bold">Select Patient:</label>
              <select
                className="form-select"
                value={billingData.patientId}
                onChange={(e) =>
                  setBillingData({ ...billingData, patientId: e.target.value })
                }
                required
              >
                <option value="">-- Select Patient --</option>
                {patients.map((patient) => (
                  <option key={patient.id} value={patient.id}>
                    {patient.firstName
                      ? `${patient.firstName} ${patient.lastName || ""}`
                      : patient.name || ""}
                  </option>
                ))}
              </select>
            </div>

            
            <div className="mb-4">
  <h5 className="fw-bold">Medicine List</h5>
  <div className="row fw-semibold mb-1">
    <div className="col-3">Medicine ID</div>
    <div className="col-4">Medicine Name</div>
    <div className="col-2">Quantity</div>
    <div className="col-2">Unit Price</div>
    <div className="col-1">Total</div>
  </div>
{billingData.medicineList.map((medicine, index) => {
  // Find selected medicine details from medicines list
  const selectedMed = medicines.find(med => String(med.id) === String(medicine.medicineId));
  // Show name: prefer backend, then master, else empty string
  const medicineName =
    (medicine.medicineName && medicine.medicineName !== "null")
      ? medicine.medicineName
      : (selectedMed?.medicineName && selectedMed?.medicineName !== "null")
      ? selectedMed.medicineName
      : (selectedMed?.name && selectedMed?.name !== "null")
      ? selectedMed.name
      : "";
  // Show unit price: prefer backend, then master, else empty string
  const unitPrice =
    (medicine.unitPrice !== null && medicine.unitPrice !== undefined)
      ? medicine.unitPrice
      : (selectedMed?.unitPrice !== null && selectedMed?.unitPrice !== undefined)
      ? selectedMed.unitPrice
      : "";
  const quantity = parseInt(medicine.quantity) || 0;
  // Show total price: prefer backend, else calculate, else empty string
  const totalPrice =
    (medicine.totalPrice !== null && medicine.totalPrice !== undefined)
      ? medicine.totalPrice
      : (unitPrice && quantity)
      ? unitPrice * quantity
      : "";

  return (
    <div className="row align-items-end mb-2" key={index}>
      {/* Medicine ID Dropdown */}
      <div className="col-3">
        <select
          className="form-select"
          value={medicine.medicineId}
          onChange={(e) => handleMedicineChange(index, 'medicineId', e.target.value)}
          required
        >
          <option value="">-- Select ID --</option>
          {medicines.map((med) => (
            <option key={med.id} value={med.id}>
              {med.id}
            </option>
          ))}
        </select>
      </div>
      {/* Medicine Name */}
      <div className="col-4">
        <input
          className="form-control"
          value={medicineName}
          disabled
          placeholder="Medicine Name"
        />
      </div>
      {/* Quantity */}
      <div className="col-2">
        <input
          type="number"
          min="1"
          className="form-control"
          value={medicine.quantity}
          onChange={(e) => handleMedicineChange(index, 'quantity', e.target.value)}
          required
        />
      </div>
      {/* Unit Price */}
      <div className="col-2">
        <input
          className="form-control"
          value={unitPrice !== "" && unitPrice !== null && unitPrice !== undefined ? unitPrice : ""}
          disabled
          placeholder="Unit Price"
        />
      </div>
      {/* Total */}
      <div className="col-1 text-end">
        {totalPrice !== "" && totalPrice !== null && totalPrice !== undefined ? `₹${totalPrice}` : "-"}
      </div>
      <div className="col-12 text-end mt-1">
        {billingData.medicineList.length > 1 && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => removeMedicine(index)}
            title="Remove"
          >
            &times;
          </button>
        )}
      </div>
    </div>
  );
})}
  <button type="button" className="btn btn-outline-primary btn-sm mt-2" onClick={addMedicine}>
    + Add Medicine
  </button>
</div>
 

            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">Consultation Fee</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={billingData.consultationFee}
                  onChange={(e) =>
                    setBillingData({ ...billingData, consultationFee: e.target.value })
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Room Charge</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={billingData.roomCharge}
                  onChange={(e) =>
                    setBillingData({ ...billingData, roomCharge: e.target.value })
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Discount</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={billingData.discount}
                  onChange={(e) =>
                    setBillingData({ ...billingData, discount: e.target.value })
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Paid Amount</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={billingData.paidAmount}
                  onChange={(e) =>
                    setBillingData({ ...billingData, paidAmount: e.target.value })
                  }
                  required
                />
              </div>
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-color btn-lg">
                Submit Billing
              </button>
            </div>
          </form>

          
        </div>
      </div>
      <div className="mt-5">
  <h4>Billing Records</h4>
  <table className=" table-bordered">
    <thead className="tableborder">
      <tr>
        <th>Billing ID</th>
        <th>Patient ID</th>
        <th>Billing Date</th>
        <th>Total Amount</th>
        <th>Paid Amount</th>
        <th>Balance Amount</th>
        <th>Medicines</th>
      </tr>
    </thead>
    <tbody>
      {billingList.map((bill) => (
        <tr key={bill.id} className='datahover'>
          <td>{bill.id}</td>
          <td>{bill.patientId}</td>
          <td>{bill.billingDate}</td>
          <td>₹{bill.totalAmount}</td>
          <td>₹{bill.paidAmount}</td>
          <td>₹{bill.balanceAmount}</td>
          <td>
            <ul className="list-unstyled mb-0">
              {bill.medicineList.map((med, idx) => (
                <li key={idx}>
                  {med.medicineName} - Qty: {med.quantity}, Unit Price: ₹{med.unitPrice}, Total: ₹{med.totalPrice}
                </li>
              ))}
            </ul>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

    </div>
  );
};

export default BillingForm;
